import React from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import { styles } from "./styles";

const PaymentCancel: React.FC = () => {
  return (
    <PageLayout>
      <div style={styles.paymentFailedBox}>
        <h1 style={styles.paymentFailedHeading}>Payment failed!</h1>
      </div>
    </PageLayout>
  );
};

export default PaymentCancel;
